import * as React from 'react';
import { History } from 'history';
import Model from './menu-model';
import BaseChecklist from '../base/base-checklist.component';
import AppService from '../../services/app.service';

interface IProps { 
  history: History;
  readOnly?: boolean
  disableBackButton? : boolean
  currentId: any;
  onLoad?: (data: any) => void;
}

interface IState {
}

export default class MenuChecklist extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): React.ReactNode {
    return (
      <BaseChecklist history={this.props.history} endPointFilter={AppService.isAppFullVersion()? Model.endPointFilterList() : Model.endPointFilterList2()} model={Model} readOnly={this.props.readOnly} currentId={this.props.currentId} onLoad={this.props.onLoad} disableBackButton/>
    );
  }
}
